export const policyFilters = [
  {
    name: 'policyDecision',
    label: 'Decision',
    options: [
      { value: 'all', label: 'All' },
      { value: 'for_review', label: 'For Review' },
      { value: 'approved', label: 'Approved' },
      { value: 'failed', label: 'Failed' },
      { value: 'excluded', label: 'Excluded' },
      { value: 'suggest_approve', label: 'Suggest Approve' },
      { value: 'suggest_exclude', label: 'Suggest Exclude' },
      { value: 'suggest_fail', label: 'Suggest Fail' },
    ]
  },
  {
    name: 'policyStatus',
    label: 'Status',
    options: [
      { value: 'all', label: 'All' },
      { value: 'PR1', label: 'PR1' },
      { value: 'PR2', label: 'PR2' },
      { value: 'PR3', label: 'PR3' },
      { value: 'undefined', label: 'Undefined' },
    ]
  },
];

export const countryFilters = [
  {
    name: 'country',
    label: 'Country',
    options: [
      { value: 'all', label: 'All Countries' },
      { value: 'AR', label: 'Argentina' },
      { value: 'AU', label: 'Australia' },
      { value: 'AT', label: 'Austria' },
      { value: 'BE', label: 'Belgium' },
      { value: 'BR', label: 'Brazil' },
      { value: 'BG', label: 'Bulgaria' },
      { value: 'CA', label: 'Canada' },
      { value: 'CO', label: 'Colombia' },
      { value: 'DK', label: 'Denmark' },
      { value: 'FI', label: 'Finland' },
      { value: 'FR', label: 'France' },
      { value: 'DE', label: 'Germany' },
      { value: 'HU', label: 'Hungary' },
      { value: 'ID', label: 'Indonesia' },
      { value: 'IE', label: 'Ireland' },
      { value: 'IT', label: 'Italy' },
      { value: 'LT', label: 'Lithuania' },
      { value: 'LU', label: 'Luxembourg' },
      { value: 'MY', label: 'Malaysia' },
      { value: 'MX', label: 'Mexico' },
      { value: 'NL', label: 'Netherlands' },
      { value: 'NZ', label: 'New Zealand' },
      { value: 'NO', label: 'Norway' },
      { value: 'PH', label: 'Philippines' },
      { value: 'PL', label: 'Poland' },
      { value: 'PT', label: 'Portugal' },
      { value: 'RO', label: 'Romania' },
      { value: 'SA', label: 'Saudi Arabia' },
      { value: 'SG', label: 'Singapore' },
      { value: 'ZA', label: 'South Africa' },
      { value: 'ES', label: 'Spain' },
      { value: 'SE', label: 'Sweden' },
      { value: 'CH', label: 'Switzerland' },
      { value: 'TW', label: 'Taiwan' },
      { value: 'TH', label: 'Thailand' },
      { value: 'GB', label: 'United Kingdom' },
      { value: 'US', label: 'United States' }
    ]
  }
];

export const dcuFilters = [
  {
    name: 'dcuCountry', label: 'Country', options: [
      { value: 'all', label: 'All Countries' },
      { value: 'AR', label: 'Argentina' },
      { value: 'AU', label: 'Australia' },
      { value: 'AT', label: 'Austria' },
      { value: 'BE', label: 'Belgium' },
      { value: 'BR', label: 'Brazil' },
      { value: 'BG', label: 'Bulgaria' },
      { value: 'CA', label: 'Canada' },
      { value: 'CO', label: 'Colombia' },
      { value: 'DK', label: 'Denmark' },
      { value: 'FI', label: 'Finland' },
      { value: 'FR', label: 'France' },
      { value: 'DE', label: 'Germany' },
      { value: 'HU', label: 'Hungary' },
      { value: 'ID', label: 'Indonesia' },
      { value: 'IE', label: 'Ireland' },
      { value: 'IT', label: 'Italy' },
      { value: 'LT', label: 'Lithuania' },
      { value: 'LU', label: 'Luxembourg' },
      { value: 'MY', label: 'Malaysia' },
      { value: 'MX', label: 'Mexico' },
      { value: 'NL', label: 'Netherlands' },
      { value: 'NZ', label: 'New Zealand' },
      { value: 'NO', label: 'Norway' },
      { value: 'PH', label: 'Philippines' },
      { value: 'PL', label: 'Poland' },
      { value: 'PT', label: 'Portugal' },
      { value: 'RO', label: 'Romania' },
      { value: 'SA', label: 'Saudi Arabia' },
      { value: 'SG', label: 'Singapore' },
      { value: 'ZA', label: 'South Africa' },
      { value: 'ES', label: 'Spain' },
      { value: 'SE', label: 'Sweden' },
      { value: 'CH', label: 'Switzerland' },
      { value: 'TW', label: 'Taiwan' },
      { value: 'TH', label: 'Thailand' },
      { value: 'GB', label: 'United Kingdom' },
      { value: 'US', label: 'United States' }
    ]
  },

  {
    name: 'connectionStatus', label: 'Connection Status', options: [
      { value: 'all', label: 'All Statuses' },
      { value: 'connected', label: 'Connected' },
      { value: 'disconnected', label: 'Disconnected' }
    ]
  },

  {
    name: 'dcus', label: 'DCUs', options: [
      { value: 'all', label: 'All' },
      { value: 'new', label: 'New' },
      { value: 'existed_before', label: 'Existed Before' }
    ]
  },

  {
    name: 'connectionChanges', label: 'Connection Changes', options: [
      { value: 'all', label: 'All' },
      { value: 'changed', label: 'Changed since last' }
    ]
  },

  {
    name: 'ppus', label: 'PPUs', options: [
      { value: 'all', label: 'All' },
      { value: 'new', label: 'New' },
      { value: 'existed_before', label: 'Existed Before' }
    ]
  },

  {
    name: 'policies', label: 'Policies', options: [
      { value: 'all', label: 'All' },
      // { value: 'new', label: 'New' },
      // { value: 'existed_before', label: 'Existed Before' }
    ]
  }
];

